export default {
  SET_SERVICES(state, services) {
    state.services = services
  },
  SET_SERVICES_COUNT(state, count) {
    state.servicesCount = count
  },
  SET_SERVICES_QUERY(state, query) {
    state.query = query
  },
  SET_SERVICES_LIMIT(state, limit) {
    state.limit = limit
  },
  SET_SERVICES_SKIP(state, skip) {
    state.skip = skip
  },
  SET_SERVICES_SORT(state, sort) {
    state.sort = sort
  }
}
